import { INSTA_ROOT } from '../instaConfig';
import axios from 'axios';

export const InstagramData = (access_token) => {

	return axios.get(`https://graph.instagram.com/me?fields=id,username&access_token=${access_token}`)
		.then(response => response)
}